import React, { useEffect, useState } from "react";

const fmtStamp = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

/** O celulă = ore într-o zi pentru un raport de muncă. Salvează la ieșirea din câmp;
 *  `onSave(value|null)` întoarce true dacă s-a salvat — altfel celula revine la valoarea anterioară. */
export default function TimeentriesCell({ entry, readOnly, onSave, testId }) {
  const stored = entry ? String(entry.hours) : "";
  const [value, setValue] = useState(stored);
  useEffect(() => { setValue(stored); }, [stored]);

  const commit = async () => {
    const raw = value.trim().replace(",", ".");
    if (raw === stored) return;
    if (raw === "") { if (!(await onSave(null))) setValue(stored); return; }
    const n = Number(raw);
    if (Number.isNaN(n) || n < 0 || n > 4) { setValue(stored); await onSave(NaN); return; }
    if (!(await onSave(n))) setValue(stored);
  };

  return (
    <>
      <input className="input te-cell" type="number" min="0" max="4" step="0.5" inputMode="decimal"
        value={value} disabled={readOnly} data-testid={testId}
        onChange={e => setValue(e.target.value)} onBlur={commit}
        onKeyDown={e => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") { setValue(stored); e.currentTarget.blur(); } }} />
      {entry && <small className="te-mod" title={`Modificat ${fmtStamp(entry.updated_at)}`}>Modificat: {fmtStamp(entry.updated_at)}</small>}
    </>
  );
}
